/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/mlsc', children: 'mlsc' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/MLSCLink.js